import { AnaColumn } from "../forms-template.service";
import { createGridConfig, gridMultiple, gridSimple } from "./gridSettings/gridSettings";
const aspect = 7.7




export const ViviFirElencoFIRBlocchi: AnaColumn[] = [


  {
    itemType: "group", caption: 'Informazioni sul blocco', colCount: "2", groupDataField: 'ViviFirElencoFIRBlocchi', data: [


      // {
      //   type: 'campoSpecial', colVisible: true, dataField: "blocco",
      //   disableOnUpdate: true,
      //   caption: "Blocco",
      //   nCol: 2,
      //   showClearButton: false,
      //   visible: false
      // },
      // {
      //   type: 'campo', colVisible: true, dataField: "descrizione",
      //   disableOnUpdate: true,
      //   caption: "Blocco",
      //   labelVisible: false,
      //   nCol: 4,
      //   showClearButton: false,
      //   visible: false
      // },

      // {
      //   type: 'campo',
      //   dataField: "numeroFirLiberi",
      //   colVisible: true,
      //   dataType: "number",
      //   caption: "N.Liberi",
      //   nCol: 2,
      //   disableOnUpdate: true,
      //   showClearButton: false,
      //   visible: false

      // },
      // {
      //   type: 'campo',
      //   dataField: "numeroFirOccupati",
      //   colVisible: true,
      //   dataType: "number",
      //   caption: "N.Occupati",
      //   nCol: 2,
      //   disableOnUpdate: true,
      //   showClearButton: false,
      //   visible: false

      // },
      // {
      //   type: 'campo',
      //   dataField: "numeroFirMassimi",
      //   colVisible: true,
      //   dataType: "number",
      //   caption: "Totale Fir",
      //   nCol: 2,
      //   disableOnUpdate: true,
      //   showClearButton: false,
      //   visible: false

      // },
      
      {
        type: 'campo', dataField: "numfir", colVisible: false, caption: "N° FIR da vidimare", hideOnEdit: false,
        editorType: 'dxNumberBox', nCol: 1,labelWidth: 100,
        validation: [

          {
            type: 'range', min: '1', max: '1000', message: 'Non puoi inserire più di 1000 FIR per volta in questo blocco',
          }
        ]
      },
      {
        type: 'simpleButton', dataField: "buttonGeneraFir",
        colVisible: false,
        class: 'button-custom  buttonGeneraFir',
        button: {
          text: 'Vidima',
          name: "generaFirBlocco",
          event: "GeneraFirBlocco",
          type: "normal",
          class: 'buttonGenera',
          hint: "Genera i fir per il blocco selezionato",
          icon: "mdi mdi-briefcase-download-outline ",
        }
      },
      { type: 'empty', colVisible: true, dataField: "" },
      { type: 'empty', colVisible: true, dataField: "" },
      {
        type: 'campo', colVisible: true, dataField: "elencoPosizioni",
        caption: "Posizioni Associate",
        nCol: 3,
        labelWidth: 100,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'PosizioneRifiuti',
          autocomplete: false,
          service: 'generic',
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Posizioni rifiuto",
          queryString: '',
          componentType: 'dynamicGrid',
          related: ['id|listaPosizioni'],
          buttonOption: {
            text: 'Lista Posizioni rifiuto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Associa Posizioni',
            name: 'poisizioneRifiuti',
            location: 'after',

          },
          settingGrid: gridMultiple

        }

      },
      {
        type: 'simpleButton', dataField: "sincronizzaFir",
        colVisible: false,
        visible:false,
        class: 'button-custom buttonSincronizzaFir',
        button: {
          text: 'Sincronizza Fir',
          name: "sincronizzaFir",
          event: "SincronizzaFir",
          type: "normal",
          class: 'buttonSincronizza',
          hint: "Sincronizza i formulari per il blocco selezionato",
          icon: "mdi mdi-sync ",
        }
      },
      { type: 'empty', colVisible: true, dataField: "" },
    ]
  },

  {
    itemType: "group", caption: 'Elenco Formulari blocco', groupWidth: 900, colCount: "1", data: [
      {
        type: 'customComponent', dataField: "elencoFormulari",
        colVisible: false,
        visible: true,
        component: {
          nameComponent: 'NicaAnagraficaComponent',
          name: 'elencoFormulari',
          configuration: {
            dataSetKey: '',
            dataFieldToSend: '',
            static: false,
            service: 'ElencoFIRPerBlocco',
            api: 'VivifirFormulari',
            remoteOperations: true,
            filter: '?blocco=[blocco]&$orderby=DataRichiesta desc',
            modifica: false,
            aggiungi: false,
            elimina: false,
            ricerca: true,
            soloRicercaGlobale: true,
            gridHeight: 470,
            gridWidth: 1010,
            id: 'ElencoFIRPerBlocco',
            orientamento: "l",
            formato: "a4",
            masterKey: "id",
            dxocolumnchooser: false,
            isExportPDFAvailable : false,
            isExportDocxAvailable : false,
            isExportExcelAvailable : false,
            showResetFilterColumn : true
          }
        }
      },
    ]
  },
] 